import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-news-event',
  templateUrl: './news-event.component.html',
  styleUrls: ['./news-event.component.scss']
})
export class NewsEventComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
